export default __webpack_public_path__ + "static/media/itago-screenshot-01.77cb5c72.png";